import {twMerge} from '@sdox/utils'

import type {ComponentProps} from 'react'

export interface DialogAsideProps extends ComponentProps<'div'> {
  size?: 'normal' | 'large'
}

const sizes = {
  normal: 'sm:w-1/3',
  large: 'sm:w-1/2',
}

export const DialogAside = ({children, className, size = 'normal', ...restProps}: DialogAsideProps) => (
  <div
    className={twMerge('w-full shrink-0 bg-surface-tertiary px-5 py-4 sm:px-12 sm:py-6 md:px-16', sizes[size], className)}
    {...restProps}
  >
    {children}
  </div>
)
